<button class="button small" (click)="addLayer()">Add new Layer</button>
@for (layr of config_.geometry.layers; track layr; let isLast = $last) {
  <div>
    <geometric-layer [layer]="layr"></geometric-layer>
    @if (!isLast) {
      <div class="horizontal-rule"></div>
    }
  </div>
}



